
import React from 'react';
import './SupportPage.css';

import SupportHero from '../../components/SupportPage/SupportHero/SupportHero';
import WhoWeHelpSection from '../../components/SupportPage/WhoWeHelpSection/WhoWeHelpSection';
import HowSupportWorksSection from '../../components/SupportPage/HowSupportWorksSection/HowSupportWorksSection';
import SlasEscalationSection from '../../components/SupportPage/SlasEscalationSection/SlasEscalationSection';
import FaqsHandbookSection from '../../components/SupportPage/FaqsHandbookSection/FaqsHandbookSection';
import StillNeedHelpCta from '../../components/SupportPage/StillNeedHelpCta/StillNeedHelpCta'; 

const SupportPage = () => {
  return (
    <div className="support-page-wrapper">
      <SupportHero />
      <WhoWeHelpSection />
      <HowSupportWorksSection />
      <SlasEscalationSection />
      <FaqsHandbookSection />
      <StillNeedHelpCta /> 
    </div>
  );
};

export default SupportPage;